import { render, staticRenderFns } from "./sale-payments.vue?vue&type=template&id=6790a92c&scoped=true"
import script from "./sale-payments.vue?vue&type=script&lang=js"
export * from "./sale-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6790a92c",
  null
  
)

export default component.exports